import { getEffectiveAccessibleModules } from './moduleRegistry';
export const NO_ACCESS_ROUTE = '/no-access';

const RESTRICTED_ROUTE_PREFIXES = Object.freeze({
  worship: ['/worship'],
  connectlessen: ['/connectlessen'],
  kinderwerk: ['/kinderwerk'],
});


export const getProjectedRestrictedModule = (user) => {
  if (!user) return null;
  if (Object.prototype.hasOwnProperty.call(user, 'restricted_module')) {
    return user.restricted_module || null;
  }

  // Rolling-deploy fallback for the immediately previous backend. Once
  // restricted_module exists in /auth/me (including an explicit null), these
  // legacy flags are ignored and cannot override the server projection.
  if (user.restricted_to_worship) return 'worship';
  if (user.restricted_to_connectlessen) return 'connectlessen';
  if (user.restricted_to_kinderwerk) return 'kinderwerk';
  return null;
};

export const isRestrictedRouteAllowed = (restrictedModule, pathname = '') => {
  if (!restrictedModule) return true;
  const prefixes = RESTRICTED_ROUTE_PREFIXES[restrictedModule] || [];
  return prefixes.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`));
};

export const resolveLandingRoute = ({ isAdmin = false, restrictedModule, accessibleModules = [] }) => {
  if (isAdmin) return '/dashboard';
  if (restrictedModule?.homeRoute) return restrictedModule.homeRoute;
  const modules = Array.from(new Map(accessibleModules.map((module) => [module.id, module])).values());
  if (modules.length === 1) return modules[0].homeRoute;
  if (modules.length >= 2) return '/dashboard';
  return NO_ACCESS_ROUTE;
};

// Pure wrapper used by login/tests. Access is read only from the server
// projection carried by the authenticated user snapshot.
export const getLandingRoute = (user) => {
  const accessibleModules = getEffectiveAccessibleModules(user);
  const restrictedHomeRoutes = {
    worship: '/worship',
    connectlessen: '/connectlessen',
    kinderwerk: '/kinderwerk',
  };
  const restrictedHomeRoute = restrictedHomeRoutes[getProjectedRestrictedModule(user)];
  const restrictedModule = restrictedHomeRoute ? { homeRoute: restrictedHomeRoute } : null;
  return resolveLandingRoute({
    isAdmin: !!user?.is_organization_admin,
    restrictedModule: accessibleModules.some((module) => module.homeRoute === restrictedModule?.homeRoute)
      ? restrictedModule : null,
    accessibleModules,
  });
};
